/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { GetTransportsTypes200, GetTransportsTypes400, GetTransportsTypesQueryResponse } from '../entities/GetTransportsTypes'
import type { ToZod } from '@kubb/plugin-zod/utils'
import { errorStructSchema } from './errorStructSchema'
import { v1GetTransportTypesResponseSchema } from './v1/getTransportTypesResponseSchema'
import { z } from 'zod'

/**
 * @description OK
 */
export const getTransportsTypes200Schema = z.lazy(() => v1GetTransportTypesResponseSchema) as unknown as ToZod<GetTransportsTypes200>

/**
 * @description Bad Request
 */
export const getTransportsTypes400Schema = z.lazy(() => errorStructSchema) as unknown as ToZod<GetTransportsTypes400>

export const getTransportsTypesQueryResponseSchema = z.lazy(() => getTransportsTypes200Schema) as unknown as ToZod<GetTransportsTypesQueryResponse>